// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3664":"141885e0fe4ff2c7","6906":"c483695b1a70a94e"}[chunkId] + ".css";
};